import ReactSelect from '../ReactSelect';
import React from 'react';

export const propertyTypeOptions = [
  {
    value: 'SINGLE_FAMILY',
    label: 'Single Family',
  },
  {
    value: 'MULTI_FAMILY',
    label: 'Multi Family',
  },
  {
    value: 'DUPLEX',
    label: 'Duplex',
  },
  {
    value: 'TRIPLEX',
    label: 'Triplex',
  },
  {
    value: 'QUADPLEX',
    label: 'Quadplex',
  },
  {
    value: 'APARTMENTS',
    label: 'Apartments',
  },
  {
    value: 'CONDOS',
    label: 'Condos',
  },
  {
    value: 'MOBILE',
    label: 'Mobile',
  },
  {
    value: 'ADULTS',
    label: 'Adults',
  },
  {
    value: 'COMMERCIAL',
    label: 'Commercial',
  },
  {
    value: 'INDUSTRIAL',
    label: 'Industrial',
  },
  {
    value: 'IRRIGATION',
    label: 'Irrigation',
  },
  {
    value: 'PUBLIC',
    label: 'Public',
  },
  {
    value: 'NONPROFIT',
    label: 'Nonprofit',
  },
  {
    value: 'WHOLESALE',
    label: 'Wholesale',
  },
  {
    value: 'FIRELINE',
    label: 'Fireline',
  },
  {
    value: 'CONSTRUCTION',
    label: 'Construction',
  },
  {
    value: 'GOVERNMENT',
    label: 'Government',
  },
  {
    value: 'AGRICULTURE',
    label: 'Agriculture',
  },
  {
    value: 'MILITARY',
    label: 'Military',
  },
  {
    value: 'COMBINATION',
    label: 'Combination',
  },
  {
    value: 'CHURCH',
    label: 'Church',
  },
  {
    value: 'RECYCLED',
    label: 'Recycled',
  },
  {
    value: 'GOLF_COURSE',
    label: 'Golf Course',
  },
  {
    value: 'MEDICAL',
    label: 'Medical',
  },
  {
    value: 'SCHOOL',
    label: 'School',
  },
] as const;

export type PropertyType = (typeof propertyTypeOptions)[number]['value'];
export type MultiOnChange = (value?: PropertyType[]) => void;
export type OnChange = (value?: PropertyType) => void;
export const PropertyTypePicker = <IsMulti extends boolean>({
  value,
  onChange,
  isMulti,
  isDisabled,
}: {
  isMulti: IsMulti;
  onChange: IsMulti extends true ? MultiOnChange : OnChange;
  value?: IsMulti extends true ? PropertyType[] : PropertyType;
  isDisabled?: boolean;
}) => {
  return (
    <ReactSelect
      placeholder="property type"
      isMulti={isMulti}
      isDisabled={isDisabled}
      isClearable={false}
      value={
        isMulti
          ? propertyTypeOptions.filter((option) =>
              value?.includes(option.value)
            )
          : propertyTypeOptions.find((option) => value === option.value)
      }
      styles={{
        menu: (base) => ({
          ...base,
          minWidth: '120px',
        }),
      }}
      onChange={(values) => {
        if (isMulti) {
          (onChange as MultiOnChange)(
            Array.isArray(values)
              ? values.length > 0
                ? values.map((value1) => value1.value as PropertyType)
                : undefined
              : undefined
          );
        } else {
          const value =
            (values as (typeof propertyTypeOptions)[number])?.value ??
            undefined;
          (onChange as OnChange)(value);
        }
      }}
      options={propertyTypeOptions}
    />
  );
};
